import { Component, Inject, Injectable, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Notify } from '../models/Personel';
import { NotifymodalComponent } from '../notifymodal/notifymodal.component';
import { PersonelService } from '../services/personel.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {

  public not: Notify;

  constructor(
    private dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public personelService: PersonelService,
    public dialog: MatDialog,
  ) {
    //okudum demeden kapatmaması için...
    //dialogRef.disableClose = true;
    this.not = data;
  }


  ngOnInit(): void {

  }

  public closeMe() {

    this.personelService.checkReadMessage(this.not.Id).subscribe(res => {
      this.dialogRef.close();
      /*
            this.dialog.open(NotifymodalComponent, {
              data: {
                isSuccess: true,
                text: "MESAJ GÖNDERİLDİ",
                subject: "Mesaj Okuma"
              }
            });*/
    },
      error => {
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess: false,
            text: error.error.error,
            subject: "Mesaj Okuma"
          }
        });
        this.dialogRef.close();
      });

  }

}
